<template>
  <div class="login">
    <div class="login-content">
      <div class="logo"><router-link to="/" title="返回首页"><img src="../assets/logo1.png" height="72" width="680"/></router-link></div>
      <div class="login-advertising">
<!--        <img src="../assets/img/login-1.png">-->
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item,index) in dataimg" :key="index"><img :src="item.url"></swiper-slide>
        </swiper>
      </div>
      <div class="login-section">
        <div class="login-section-tit" :class="mplogin?'cut':''" style="padding-left: 0"><span @click="getlogway(false)">账号登录</span><span style="opacity: 0">手机号登录</span></div><!--@click="getlogway(true)"-->
        <p :style="tit?'':'display:none'">{{titexplain}}</p>
        <div class="login-section-con"><!--error 错误时添加-->
          <div :class="nameerror?'error':''"><label>账号</label><input name="username" v-model="username" @change="cleartit()"></div>
          <div :class="passworderror?'error':''"><label>密码</label><input name="password" v-model="password" :type="chakan?'':'password'" @change="cleartit()" @keyup.enter="gologin()"><em class="porc iconfont" @click="getchakan(chakan)" :class="chakan?'icon-xianshikejian':'icon-yincangbukejian'"></em></div>
          <div :class="vcodeerror?'error':''">
            <label>验证码</label>
            <input name="password" v-model="vcode" @change="cleartit()" autocomplete="off" @keyup.enter="gologin()" style="width: 158px; display: inline-block">
            <img :src="imgUrl" @click="getVerifyCode" title="点击刷新" class="vcodeimg"/>
          </div>
          <p style="margin-top: 2px"><span @click="getjizhumima(jzmm)"><em class="jizhumima iconfont" :class="jzmm?'blues icon-fangxingxuanzhongfill':'icon-fangxingweixuanzhong'"></em>记住密码</span><span>忘记密码</span></p>
          <a @click="gologin()" class="submit-btn" style="margin-top: 24px" v-html="submitname"></a>
          <span class="reg-register-link">没有账号，<a @click="goregister">立即注册</a></span>
        </div>
      </div>
    </div>
    <p class="copyright">© {{ new Date().getFullYear() }} 浙江萧山化学纤维产业大脑有限公司版权所有&nbsp;&nbsp;v{{version}} &nbsp;&nbsp;备案号：<a href="http://beian.miit.gov.cn/" target="_blank">
      {{ recordicp }}</a><img
      src="../assets/home/ba.png" height="22" width="20" style="vertical-align: sub; margin-left: 12px"/><a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+recordpublic" rel="noopener" target="_blank"> 公网备案：{{ recordpublic }}</a></p>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import myStorage, {insertStr} from "../bll/utils";
export default {
  name: 'Login',
  components:{
    swiper,
    swiperSlide
  },
  data () {
    return {
      chakan:false,
      jzmm:false,
      mplogin:false,
      nameerror:false,
      passworderror:false,
      vcodeerror:false,
      issubmit:true,
      submitname:'登录',
      password:'',
      username:'',
      vcode:'',
      imgUrl:'',
      uuid:'',
      swiperOption: {//swiper3
        autoplay: 3000,
        speed: 1000,
        loop: true
      },
      tit:false,
      titexplain:'',
      dataimg:[
        {url:require('../assets/img/login-1.png')},
        {url:require('../assets/img/login-2.png')},
        {url:require('../assets/img/login-3.png')},
        {url:require('../assets/img/login-4.png')},
      ],
      version:this.$versionclient,
      recordicp:process.env.RECORD=='production'?'浙ICP备2022025995号':'浙ICP备2022025995号-2',
      recordpublic:process.env.RECORD=='production'?'33010902003449':'33010902003449'
    }
  },
  created() {
  },
  mounted() {
    this.getCookie()
    this.getVerifyCode()
  },
  methods:{
    getchakan(st){
      var num=this.password
      this.chakan=!st
      this.password=num
    },
    getjizhumima(st){
      this.jzmm=!st
    },
    getlogway(st){
      this.mplogin=st
    },
    gologin(){
      var $this=this
      if(!$this.issubmit){
        return
      }
      if($this.username==''){
        $this.titexplain='账号不能为空！'
        $this.tit=true
        $this.nameerror=true
        return
      }
      if($this.password==''){
        $this.titexplain='密码不能为空！'
        $this.tit=true
        $this.passworderror=true
        return
      }
      if($this.vcode==''){
        $this.titexplain='验证码不能为空！'
        $this.tit=true
        $this.vcodeerror=true
        return
      }
      $this.issubmit=false
      $this.submitname='登录中<img class="login-img" src="'+require('../assets/loading1.gif')+'"/>'

      const url = '/api-ca/login/loginportal';
      this.$api.post(url, {
        loginname:$this.username,
        password:this.$md5(insertStr($this.password)),
        uuid: this.uuid,
        code: this.vcode
      }, (response) => {
        let datas=response.data||''
        let token=response.headers.token||''
        let isReload=response.headers.isreload||''
        myStorage.setItem('localStorage','token', token)
        if(datas.code=='000000'&&token){
          if($this.jzmm===true){
            $this.setCookie($this.username,$this.password,true,7)
          }else {
            $this.clearcookie()
          }
          let test=datas.data // {"phone":"18888888888","userName":"admin","userId":888}
          myStorage.setItem('localStorage','userinfo', test)
          if(isReload){
            localStorage.setItem('accountid',test.accountid)
            localStorage.setItem('tokens',token)
          }else {
            localStorage.removeItem('accountid')
            localStorage.removeItem('tokens')
          }
          let gotos=localStorage.getItem('gotourl')
          if(gotos&&gotos!='/login'){
            localStorage.removeItem('gotourl')
            if(gotos.indexOf('http')<0){
              let routeData = $this.$router.resolve({path: gotos})
              // window.open(routeData.location.hash,'_self')
              location.replace(routeData.location.hash)
            }else {
              // window.open(gotos,'_self')
              location.replace(gotos)
            }
          }else {
            $this.$router.replace('/homepage')
          }
        }else {
          $this.titexplain=datas.message
          $this.submitname='登录'
          $this.tit=true
          $this.passworderror=true
          $this.nameerror=true
          $this.vcodeerror=true
          $this.issubmit=true
          this.getVerifyCode()
        }
      },'json');
    },
    getVerifyCode() {
      const uuid = this.guid()
      this.uuid = uuid
      const params = {
        uuid: this.uuid,
      };
      const url = '/api-ca/captcha/getCode';
      this.$api.get(url, params, (response) => {
        if (response.data.code == "000000") {
          this.imgUrl = "data:image/gif;base64," + response.data.data;
        }
      },'json')
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    cleartit(){
      var $this=this
      $this.tit=false
      $this.nameerror=false
      $this.passworderror=false
      $this.vcodeerror=false
      $this.titexplain=''
    },
    setCookie(name,pwd,state,days){
      const exdate=new Date()
      exdate.setTime(exdate.getTime()+24*60*60*1000*days)
      window.document.cookie='username'+'='+name+';path=/;expires='+exdate.toGMTString()
      window.document.cookie='password'+'='+pwd+';path=/;expires='+exdate.toGMTString()
      window.document.cookie='state'+'='+state+';path=/;expires='+exdate.toGMTString()
    },
    getCookie(){
      var $this=this
      if(document.cookie.length>0){
        const arr=document.cookie.split(';')
        for(let i=0;i<arr.length;i++){
          const arr2=arr[i].split('=')
          if(arr2[0]=='username'){
            $this.username=arr2[1]
          }else if(arr2[0]==' password'){
            $this.password=arr2[1]
          }else if(arr2[0]==' state'){
            $this.jzmm=Boolean(arr2[1])
          }
        }
      }
    },
    clearcookie(){
      this.setCookie('','',false,-1)
    },
    goregister(){
      this.$router.push('/register')
    }
  }
}
</script>

<style scoped>
.login{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  background: url("../assets/login-bj.jpg") no-repeat center center;
  justify-content: center;
  align-items: center;
}

.copyright{
  position: fixed;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #fff;
}

.copyright a{
  color: #fff;
}
.copyright a:hover{
  color: yellow;
}

.login-content{
  width: 1042px;
  height: 514px;
  background: rgba(99,175,245,.85);
  border-radius: 17px;
  display: flex;
  box-shadow: 3px 16px 13px rgba(0,0,0,.54);
  position: relative;
}

.logo{
  position: absolute;
  left: 0;
  top: -85px;
  width: 100%;
  text-align: center;
}

.login-advertising{
  width: 671px;
  height: 100%;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  overflow: hidden;
}

.login-section{
  flex: 1;
  border-top-right-radius: 19px;
  border-bottom-right-radius: 19px;
  background: rgba(255,255,255,.85);
}

.login-section>p{
  width: 289px;
  margin: 0 auto;
  margin-bottom: 5px;
  font-size: 14px;
  color: red;
}

.login-section-tit{
  font-size: 21px;
  color: #111;
  font-weight: bold;
  position: relative;
  display: flex;
  justify-content: center;
  margin: 30px 20px 20px;
}

.login-section-tit span{
  padding: 13px 20px;
  cursor: pointer;
}

.login-section-tit:before{
  content: "";
  position: absolute;
  width: 30px;
  height: 4px;
  background-color: #265DED;
  display: block;
  bottom: 0;
  left: 78px;
  box-shadow: 0 2px 2px rgba(0,0,0,.2);
  border-radius: 2px;
  transition-delay: .1s, 0s;
  transition-duration: .3s, .3s;
}
.cut:before{
  left: 212px;
}

.login-section-con{
  width: 289px;
  margin: 0 auto;
}

.login-section-con>div{
  margin-bottom: 10px;
  position: relative;
}

.login-section-con>div label{
  margin-bottom: 6px;
  display: block;
  color: #A9B0BA;
}

.login-section-con>p{
  display: flex;
  margin-top: -8px;
  font-size: 14px;
  justify-content: space-between;
  color: #666;
}

.login-section-con>p span:last-child{
  color: #5D86F0;
  cursor: pointer;
}

.login-section-con>p span:hover{
  color: #3065EE;
  cursor: pointer;
}

.blues{
  color: #3065EE;
}

.jizhumima{
  display: inline-block;
  vertical-align: middle;
  margin-right: 3px;
  font-size: 18px;
  cursor: pointer;
  margin-top: -3.5px;
}

.login-section-con input{
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 48px;
  border: 1px solid #CFD7E1;
  padding: 0 12px;
  font-size: 16px;
  border-radius: 6px;
  color: #09090A;
}

.error input{
  border-color: red;
}

.login-section-con input:focus{
  outline: 1px solid #3065EE;
  border: 1px solid #3065EE;
}

.error input:focus{
  outline: 1px solid red;
  border-color: red;
}

.porc{
  position: absolute;
  right: 4px;
  bottom: 5px;
  width: 28px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  color: #CAD2DC;
  font-size: 21px;
}

.porc:hover{
  color: #999;
}

.icon-yincangbukejian{
  color: #999;
}

  .reg-register-link{
    display: block;
    text-align: center;
    margin-top: 12px;
    font-size: 14px;
  }

.reg-register-link a{
  color: #2F489E;
  cursor: pointer;
}
.vcodeimg{
  height: 43px;
  width: 120px;
  vertical-align: middle;
  border: 1px solid #CFD7E1;
  padding: 2px;
  border-radius: 6px;
  cursor: pointer;
}
.vcodeimg:hover{
  border-color: #154EF7;
}
</style>

<style>
  .login-img{
    display: inline-block;
    vertical-align: middle;
    margin-top: -7px;
    width: 24px;
    height: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/views/login.vue